module.exports = __webpack_public_path__ + "static/media/incident_category-production.99358377.svg";